export interface StpChartTokens {
  readonly fontFamily: string
  readonly fontSize: number
  readonly textColor: string
  readonly mutedColor: string
  readonly borderColor: string
  readonly splitLineColor: string
  readonly palette: readonly string[]
  readonly lineWidth: number
}

export const stpChartTokens: StpChartTokens = {
  fontFamily: 'Rubik, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  fontSize: 12,
  textColor: '#1D2129',
  mutedColor: '#86909C',
  borderColor: '#E5E7EB',
  splitLineColor: '#E5E7EB',
  palette: [
    '#4E79A7',
    '#F28E2B',
    '#59A14F',
    '#E15759',
    '#B07AA1',
    '#76B7B2',
    '#6D28D9',
    '#BCBD22',
    '#8C6D31',
    '#332288',
    '#882255',
    '#FF9DA7',
    '#3D64E7',
    '#DDCC77',
    '#C2410C',
    '#33BBEE',
    '#9467BD',
    '#7F7F7F',
    '#843C39',
    '#393B79',
  ],
  lineWidth: 3,
}
